import Vue from 'vue'

//import BootstrapVue from 'bootstrap-vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Every <b-table> in the app defaults to showing an empty-state row instead
// of silently rendering nothing when its data is empty — no b-table view
// currently sets show-empty/empty-text itself, so this is a single point of
// control rather than 28 separate edits. Any view can still override these
// props locally if it needs different copy.
Vue.use(BootstrapVue, {
  BTable: {
    showEmpty: true,
    emptyText: 'ไม่มีข้อมูล',
    emptyFilteredText: 'ไม่พบข้อมูลที่ค้นหา',
  },
})
Vue.use(BootstrapVueIcons)
